import { render, staticRenderFns } from "./ElementResultTableColumn.vue?vue&type=template&id=28ae032e&scoped=true"
import script from "./ElementResultTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementResultTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementResultTableColumn.vue?vue&type=style&index=0&id=28ae032e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae032e",
  null
  
)

export default component.exports